module.exports = __webpack_public_path__ + "static/img/3.36c4bfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news20/3.png
// module id = vJbC
// module chunks = 1